<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8">
          Política de Cookies
        </h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-lg text-base-content/80 mb-8">
            Esta Política de Cookies explica qué son las cookies y cómo las
            utilizamos en nuestro sitio web.
          </p>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ¿QUÉ SON LAS COOKIES?
            </h2>
            <p class="text-base-content/80 mb-4">
              Las cookies son pequeños archivos de texto que se almacenan en su
              dispositivo (ordenador, tableta o móvil) cuando visita un sitio
              web. Permiten al sitio web recordar sus acciones y preferencias
              (como inicio de sesión, idioma, tamaño de fuente y otras
              preferencias de visualización) durante un período de tiempo, por
              lo que no tiene que volver a introducir estos datos cada vez que
              regrese al sitio o navegue de una página a otra.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ¿CÓMO UTILIZAMOS LAS COOKIES?
            </h2>
            <p class="text-base-content/80 mb-4">
              DESERTANDO hace uso de cookies propias y de terceros para mejorar
              la experiencia del usuario en nuestro sitio web. Utilizamos las
              cookies para:
            </p>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li>Permitir el funcionamiento básico del sitio web</li>
              <li>Recordar sus preferencias de navegación</li>
              <li>Analizar el tráfico y uso del sitio web</li>
              <li>Mejorar nuestros servicios y contenidos</li>
              <li>Mostrar contenido personalizado cuando sea apropiado</li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              TIPOS DE COOKIES QUE UTILIZAMOS
            </h2>

            <div class="space-y-6">
              <div class="bg-base-200 p-6 rounded-lg">
                <h3 class="text-xl font-semibold text-base-content mb-3">
                  🔧 Cookies Técnicas y Funcionales
                </h3>
                <p class="text-base-content/80">
                  <strong>Propósito:</strong> Son necesarias para el
                  funcionamiento básico del sitio web y permiten la navegación y
                  el uso de diferentes opciones o servicios.
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Duración:</strong> Sesión (se eliminan al cerrar el
                  navegador)
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Necesarias:</strong> Sí, no se pueden deshabilitar
                </p>
              </div>

              <div class="bg-base-200 p-6 rounded-lg">
                <h3 class="text-xl font-semibold text-base-content mb-3">
                  📊 Cookies Analíticas
                </h3>
                <p class="text-base-content/80">
                  <strong>Propósito:</strong> Nos permiten conocer cómo los
                  usuarios interactúan con nuestro sitio web, ayudándonos a
                  mejorar el rendimiento y la experiencia del usuario.
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Duración:</strong> Hasta 2 años
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Necesarias:</strong> No, se pueden deshabilitar
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Servicios de terceros:</strong> Google Analytics
                </p>
              </div>

              <div class="bg-base-200 p-6 rounded-lg">
                <h3 class="text-xl font-semibold text-base-content mb-3">
                  ⚙️ Cookies de Personalización
                </h3>
                <p class="text-base-content/80">
                  <strong>Propósito:</strong> Permiten recordar información para
                  que el usuario acceda al servicio con determinadas
                  características (idioma, región, etc.).
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Duración:</strong> Variable (desde sesión hasta 1 año)
                </p>
                <p class="text-base-content/80 mt-2">
                  <strong>Necesarias:</strong> No, se pueden deshabilitar
                </p>
              </div>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              GESTIÓN DE COOKIES
            </h2>
            <p class="text-base-content/80 mb-4">
              Puede aceptar o rechazar las cookies, así como configurar qué
              tipos de cookies desea permitir. La mayoría de navegadores aceptan
              cookies automáticamente, pero usted puede modificar la
              configuración de su navegador para rechazarlas si lo prefiere.
            </p>

            <div class="bg-warning/10 border-l-4 border-warning p-4 mb-6">
              <p class="text-base-content/80">
                <strong>Importante:</strong> Si deshabilita las cookies, es
                posible que algunas funciones del sitio web no funcionen
                correctamente.
              </p>
            </div>

            <h3 class="text-xl font-semibold text-base-content mb-3">
              Configuración por navegador:
            </h3>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li class="mb-2">
                <strong>Chrome:</strong> Configuración > Privacidad y seguridad
                > Cookies y otros datos de sitios
              </li>
              <li class="mb-2">
                <strong>Firefox:</strong> Opciones > Privacidad y seguridad >
                Cookies y datos del sitio web
              </li>
              <li class="mb-2">
                <strong>Safari:</strong> Preferencias > Privacidad > Cookies y
                datos de sitios web
              </li>
              <li>
                <strong>Edge:</strong> Configuración > Privacidad, búsqueda y
                servicios > Cookies
              </li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              COOKIES DE TERCEROS
            </h2>
            <p class="text-base-content/80 mb-4">
              Nuestro sitio web puede contener enlaces a sitios web de terceros.
              No tenemos control sobre las políticas de cookies de estos sitios
              web externos, por lo que le recomendamos que revise sus políticas
              de cookies.
            </p>

            <div class="bg-base-200 p-6 rounded-lg">
              <h3 class="text-xl font-semibold text-base-content mb-3">
                Servicios de terceros que pueden utilizar cookies:
              </h3>
              <ul class="list-disc pl-6 text-base-content/80">
                <li>
                  <strong>Google Analytics:</strong> Para análisis de tráfico
                  web
                </li>
                <li>
                  <strong>Redes sociales:</strong> Para funcionalidades de
                  compartir contenido
                </li>
                <li>
                  <strong>Servicios de mapas:</strong> Para mostrar ubicaciones
                </li>
                <li>
                  <strong>Sistemas de pago:</strong> Para procesar transacciones
                  seguras
                </li>
              </ul>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              CONSENTIMIENTO
            </h2>
            <p class="text-base-content/80 mb-4">
              Al utilizar nuestro sitio web, usted consiente el uso de cookies
              de acuerdo con esta Política de Cookies. Si no desea que
              utilicemos cookies, puede configurar su navegador para rechazarlas
              o puede abandonar nuestro sitio web.
            </p>
            <p class="text-base-content/80">
              El consentimiento para el uso de cookies se puede retirar en
              cualquier momento modificando la configuración de su navegador.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ACTUALIZACIONES DE ESTA POLÍTICA
            </h2>
            <p class="text-base-content/80 mb-4">
              Podemos actualizar esta Política de Cookies periódicamente para
              reflejar cambios en nuestras prácticas o por otras razones
              operativas, legales o reglamentarias.
            </p>
            <p class="text-base-content/80">
              Le recomendamos que revise esta página regularmente para
              mantenerse informado sobre cómo utilizamos las cookies.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              CONTACTO
            </h2>
            <p class="text-base-content/80 mb-4">
              Si tiene alguna pregunta sobre esta Política de Cookies, puede
              contactarnos:
            </p>
            <div class="bg-base-200 p-6 rounded-lg">
              <p class="text-base-content/80 mb-2">
                <strong>DESERTANDO CLUB DE AVENTURAS, S.L.</strong>
              </p>
              <p class="text-base-content/80 mb-2">
                Dirección: C/ Arturo Soria, 333 – 28033 Madrid, España
              </p>
              <p class="text-base-content/80 mb-2">
                Teléfono: (+34) 608 76 29 62 / (+34) 620 50 17 61
              </p>
              <p class="text-base-content/80">
                Email:
                <a
                  href="mailto:info@soleando.eu"
                  class="text-primary hover:underline"
                  >info@soleando.eu</a
                >
              </p>
            </div>
          </section>

          <div class="text-center pt-8 border-t border-base-300">
            <p class="text-sm text-base-content/60">
              Última actualización: Enero 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Política de Cookies - Soleando",
  description:
    "Política de cookies de Soleando. Información sobre el uso de cookies en nuestro sitio web.",
});
</script>

<style scoped></style>
